


















































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { ServiceRequestModel } from '../../types/request';
import { MedTransGoConstants } from '../../util/constants';
import { ObjectFactory } from '../../config/objectFactory';
import { BLSServiceOptions, Language } from '../../types/entity';
import { required } from 'vuelidate/lib/validators';
import { ModelSelect } from 'vue-search-select';
import { DateUtils } from '@/util/dateUtils';
// tslint:disable-next-line: no-var-requires
const validationErrorMessages = require('../../config/validationErrorMessages.json');

@Component({
    props: {
        serviceRequest: Object,
    },
    data() {
        return {
            validationErrorMessages: [],
            showRequiredFieldMessage: false,
            isLanguageMsgAdded: false,
            isInvalidTimeMsgAdded: false,
            formValidation : {
                isLanguageValid: false,
                isInterpretationHoursValid: true,
                isInterpretationHoursErrorMessage: '',
                isInterpretationMinutesValid: true,
                isInterpretationMinutesErrorMessage: '',
                isFormValid: false,
            },
            showImmeditateRequestWarning: false,
            showLessTimeWarning: false,
        };
    },
    watch: {
        serviceRequest: {
            handler(newValue, oldValue) {
                if (this.$v.$invalid) {
                    this.$props.serviceRequest.stops.isStop2Valid = false;
                } else {
                    this.$props.serviceRequest.stops.isStop2Valid = true;
                }
            },
            deep: true,
            immediate: true,
        },
    },
    methods: {
        validateHours() {
            const hours = this.$props.serviceRequest.interpretation.estimatedTime.hours;
            if (hours > 23 || hours < 0) {
                this.$data.formValidation.isInterpretationHoursValid = false;
                this.$data.formValidation.isInterpretationHoursErrorMessage = 'Please enter a valid number between 0 and 23 for hours.';
            } else {
                this.$data.formValidation.isInterpretationHoursValid = true;
                this.$data.formValidation.isInterpretationHoursErrorMessage = '';
            }
        },
        validateMinutes() {
            const minutes = this.$props.serviceRequest.interpretation.estimatedTime.minutes;
            if (minutes > 59 || minutes < 0) {
                this.$data.formValidation.isInterpretationMinutesValid = false;
                this.$data.formValidation.isInterpretationMinutesErrorMessage = 'Please enter a valid number between 0 and 59 for minutes.';
            } else {
                this.$data.formValidation.isInterpretationMinutesValid = true;
                this.$data.formValidation.isInterpretationMinutesErrorMessage = '';
            }
        },
        restrictToNumbers(event) {
            const charCode = event.which ? event.which : event.keyCode;
            if (charCode < 48 || charCode > 57) {
            event.preventDefault();
            }
        },
    },
    validations(): any {
        const validations: any = {
            serviceRequest: {
                transportation: {
                    visitType: {
                        required,
                    },
                    vehicleType: {
                        required,
                    },
                    blsServiceOptions: {
                        required,
                    },
                    isOxygenTankRequired: {
                        required,
                    },
                    mentalHealth: {
                        required,
                    },
                    caregiver: {
                        required,
                    },
                    isWheelchairProvided: {
                        required,
                    },
                    providedWheelchairOption: {
                        required,
                    },
                },
                patient: {
                    patientHeight: {
                        feet: {
                            required,
                        },
                        inch: {
                            required,
                        },
                    },
                    patientWeight: {
                        required,
                    },
                },
                interpretation: {
                    serviceType: {
                        required,
                    },
                    isMedicalInterpretation: {
                        required,
                    },
                },
            },
        };
        if (this.$props.serviceRequest.transportation.vehicleType !== 'BLS') {
            delete validations.serviceRequest.transportation.blsServiceOptions;
        }
        if (!this.$props.serviceRequest.transportation.vehicleType) {
            delete validations.serviceRequest.transportation.isBariatricServiceRequired;
        }
        if (!this.$props.serviceRequest.transportation.mentalHealth) {
            delete validations.serviceRequest.transportation.caregiver;
        }
        if (this.$props.serviceRequest.transportation.vehicleType === 'Wheelchair' &&
            this.$props.serviceRequest.transportation.isWheelchairProvided === 'Yes') {
            delete validations.serviceRequest.transportation.providedWheelchairOption;
        }
        if (this.$props.serviceRequest.transportation.vehicleType === 'Sedan' ||
            this.$props.serviceRequest.service.type !== 'Transportation') {
            delete validations.serviceRequest.transportation.isBariatricServiceRequired;
            delete validations.serviceRequest.patient.patientWeight;
            delete validations.serviceRequest.patient.patientHeight.inch;
            delete validations.serviceRequest.patient.patientHeight.feet;
        }
        if (this.$props.serviceRequest.transportation.vehicleType !== 'Wheelchair') {
            delete validations.serviceRequest.transportation.isWheelchairProvided;
            delete validations.serviceRequest.transportation.providedWheelchairOption;
        }
        if (this.$props.serviceRequest.service.type !== 'Interpretation') {
            delete validations.serviceRequest.interpretation;
        }
        if (this.$props.serviceRequest.service.type !== 'Transportation') {
            delete validations.serviceRequest.transportation;
        }
        this.$data.validationErrorMessages = [];
        this.$data.isLanguageMsgAdded = false;
        this.$data.isInvalidTimeMsgAdded = false;
        const isEmpty = (value: any) => {
            return value === undefined || value === null || value === '';
        };
        Object.keys(validations.serviceRequest).forEach((category: any) => {
            Object.keys(validations.serviceRequest[category]).forEach((field: any) => {
                const fieldValue = this.$props.serviceRequest[category][field];
                const fieldValidation = validations.serviceRequest[category][field];
                if (fieldValue && typeof fieldValue === 'object' && !Array.isArray(fieldValue)) {
                    Object.keys(fieldValue).forEach((subField: any) => {
                    const subFieldValue = fieldValue[subField];
                    const subFieldValidation = fieldValidation[subField];
                    if (subFieldValidation && subFieldValidation.required && isEmpty(subFieldValue)) {
                        const path = `${category}.${field}.${subField}`;
                        const keys = path.split('.');
                        let value = validationErrorMessages;

                        for (const key of keys) {
                            value = value[key];
                        }

                        if (value) {
                            this.$data.validationErrorMessages.push(value);
                        }
                    }
                    });
                } else if (Array.isArray(fieldValue)) {
    // Handle array validation
                if (validations.serviceRequest[category][field].required && fieldValue.length === 0) {
                    const path = `${category}.${field}`;
                    const keys = path.split('.');
                    let value = validationErrorMessages;

                    for (const key of keys) {
                        value = value[key];
                    }

                    if (value) {
                        this.$data.validationErrorMessages.push(value);
                    }
                } else {
                    // Optional: Add custom validation logic for array elements if needed
                    fieldValue.forEach((item, index) => {
                        if (isEmpty(item)) {
                            const path = `${category}.${field}[${index}]`;
                            const keys = path.split('.');
                            let value = validationErrorMessages;

                            for (const key of keys) {
                                value = value[key];
                            }

                            if (value) {
                                this.$data.validationErrorMessages.push(value);
                            }
                        }
                    });
                }
            } else if (validations.serviceRequest[category][field].required &&
                    isEmpty(this.$props.serviceRequest[category][field])) {
                    const path = `${category}.${field}`;
                    const keys = path.split('.');
                    let value = validationErrorMessages;
                    for (const key of keys) {
                        value = value[key];
                    }
                    if (field === 'isBariatricServiceRequired') {
                        if (this.$props.serviceRequest.transportation.vehicleType === 'Wheelchair') {
                            const updatedValue = value.replace('service', 'wheelchair');
                            value = updatedValue;
                        } else {
                            const updatedValue = value.replace('service', 'stretcher');
                            value = updatedValue;
                        }
                    }
                    this.$data.validationErrorMessages.push(value);
                }
            });
            if (validations.serviceRequest[category].required &&
                this.$props.serviceRequest[category] === undefined) {
                const value = validationErrorMessages[category];
                this.$data.validationErrorMessages.push(value);
            }
            if (this.$props.serviceRequest.service.type === 'Interpretation') {
                if (!this.$data.formValidation.isLanguageValid) {
                    const keys = ['interpretation', 'language'];
                    let value = validationErrorMessages;
                    for (const key of keys) {
                        value = value[key];
                    }
                    if (value && !this.$data.isLanguageMsgAdded) {
                        this.$data.validationErrorMessages.push(value);
                        this.$data.isLanguageMsgAdded = true;
                    }
                }
                if (!this.$data.formValidation.isInterpretationHoursValid
                    || !this.$data.formValidation.isInterpretationMinutesValid) {
                    const keys = ['interpretation', 'estimatedTime'];
                    let value = validationErrorMessages;
                    for (const key of keys) {
                        value = value[key];
                    }
                    if (value && !this.$data.isInvalidTimeMsgAdded) {
                        this.$data.validationErrorMessages.push(value);
                        this.$data.isInvalidTimeMsgAdded = true;
                    }
                }
            }
        });
        return validations;
    },
    components: {
        ModelSelect,
    },
})
export default class VehicleLanguage extends Vue {
    private languages: Language[] = [];
    private languageOptions: Array<{ value: any, text: any }> = [];
    private interpretationServiceTypes = {
        'Phone': 1,
        'In-Person': 2,
        'Video': 1,
    };
    // This variable is used to manage question number
    private questionCounter = 0;
    private activeOptions: BLSServiceOptions[] = [];
    private isVehicleTypeDisabled = false;


    public mounted() {
        const element = document.querySelector('.my-class') as Element;
        if (element) {
            element.scrollIntoView({ behavior: 'smooth'});
        }

        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (serviceRequest.transportation) {
            const appointmentTime = DateUtils.convertToUTCInMillis(serviceRequest.appointments[0].date + ' ' +
            serviceRequest.appointments[0].time, serviceRequest.appointments[0].timezone);
            if (serviceRequest.transportation.isImmediateTransportation) {
                this.isVehicleTypeDisabled = true;
                this.$data.showImmeditateRequestWarning = true;
            } else if (appointmentTime < (DateUtils.getCurrentTimeInMillis() + DateUtils.convertMinutesToMillis(180))) {
                this.isVehicleTypeDisabled = true;
                this.$data.showLessTimeWarning = true;
            }
        }
        if (serviceRequest.languages) {
            this.languages = serviceRequest.languages;
        }
        if (!serviceRequest.stops.isStop1Valid) {
            this.$router.push({ path: MedTransGoConstants.URL_SERVICE_REQUEST_SERVICE_VISIT });
        } else {
            if (serviceRequest.service.type === 'Transportation') {
                this.questionCounter = 0;
            } else if (serviceRequest.service.type === 'Interpretation') {
                this.questionCounter = 2;
            }
            this.validateForm();
        }

        if (serviceRequest.interpretation) {
            this.getLanguages(this.interpretationServiceTypes[serviceRequest.interpretation.serviceType]);
        }
        // if (serviceRequest.transportation && serviceRequest.transportation.visitType === 'Non-Procedure') {
        //     serviceRequest.transportation.conciergeService = false;
        // }
    }
    private async getLanguages(serviceType: number) {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (!serviceRequest.languages) {
            const response = await ObjectFactory.getRequestService().getLanguages(serviceType,
                this.$store.state.serverUrl);
            if (response.data) {
                this.languages = response.data;
                serviceRequest.languages = response.data;
            }
        }
        if (this.languageOptions.length < 1) {
            this.languages.forEach((language) => {
                const option = {
                    value: language.name,
                    text: language.name,
                };
                this.languageOptions.push(option);
            });
        }
        this.validateForm();
    }
    private isNumber(evt: KeyboardEvent) {
        const keysAllowed: string[] = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.'];
        const keyPressed: string = evt.key;
        if (!keysAllowed.includes(keyPressed)) {
            evt.preventDefault();
        }
    }
    private validateForm() {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (serviceRequest.service.type === 'Transportation') {
            this.$data.formValidation.isFormValid = true;
            return;
        } else {
            if (serviceRequest.interpretation) {
                this.$data.formValidation.isFormValid = false;
                if (!serviceRequest.interpretation.language) {
                    this.$data.formValidation.isLanguageValid = false;
                } else {
                    this.$data.formValidation.isLanguageValid = true;
                }
                const { minutes, hours } = serviceRequest.interpretation.estimatedTime;
                if ((!serviceRequest.interpretation.isImmediateInterpretation) &&
                    (!hours || hours <= 0) &&
                    (!minutes || minutes < 30)) {
                    this.$data.formValidation.isInterpretationHoursValid = false;
                    this.$data.formValidation.isInterpretationHoursErrorMessage = 'Minimum of 30 Minutes required';
                } else if (!serviceRequest.interpretation.isImmediateInterpretation &&
                    (
                        (hours && isNaN(hours)) ||
                        (minutes && isNaN(minutes))
                    )) {
                    this.$data.formValidation.isInterpretationHoursValid = false;
                    this.$data.formValidation.isInterpretationHoursErrorMessage = 'Estimated time must be a valid duration';
                } else {
                    this.$data.formValidation.isInterpretationHoursValid = true;
                }
                this.$data.formValidation.isFormValid = this.$data.formValidation.isInterpretationHoursValid
                    && this.$data.formValidation.isLanguageValid;
            }
        }
    }
    private nextStep() {
        if (this.$v.$invalid || !this.$data.formValidation.isFormValid) {
            this.$data.showRequiredFieldMessage = true;
        } else {
            this.$props.serviceRequest.stops.isStop2Valid = true;
            this.$router.push({ path: MedTransGoConstants.URL_SERVICE_REQUEST_ADDRESS_BILLING });
        }
        if (this.$props.serviceRequest.transportation && this.$props.serviceRequest.transportation.conciergeService) {
            this.$props.serviceRequest.transportation.visitType = 'Procedure';
        }
    }
    private preStep() {
        this.$router.go(-1);
    }
    private selectMentalHealthPatient(value: boolean) {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (serviceRequest.transportation) {
            serviceRequest.transportation.mentalHealth = value;
        }
    }
    private selectOxygenTank(value: boolean) {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (serviceRequest.transportation) {
            serviceRequest.transportation.isOxygenTankRequired = value;
        }
    }

    private selectbariatricServices(value: any) {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (serviceRequest.transportation) {
            serviceRequest.transportation.isBariatricServiceRequired = value;
        }
    }
    private selectIfWheelchairIsProvided(value: any) {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (serviceRequest.transportation) {
            serviceRequest.transportation.isWheelchairProvided = value;
        }
    }
    private selectCovidSymptoms(value: boolean) {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (serviceRequest.transportation) {
            serviceRequest.transportation.hasCovidSymptoms = value;
        }
    }

    private setDefaultHours() {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (serviceRequest.interpretation) {
            if (serviceRequest.interpretation.isImmediateInterpretation) {
                serviceRequest.interpretation.estimatedTime.hours = 0;
                serviceRequest.interpretation.estimatedTime.minutes = 15;
            } else {
                serviceRequest.interpretation.estimatedTime.hours = 1;
            }
        }
        this.validateForm();
    }

    private onLanguageSelected() {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        serviceRequest.preferredProviderRequired = null as any;
        if (serviceRequest.interpretation && serviceRequest.interpretation.language) {
            ObjectFactory.getOrganizationService()
                .getPreferredProviders(this.$store.state.serverUrl, serviceRequest.interpretation.language)
                .then((response) => {
                    this.$store.commit('SET_PREFERRED_PROVIDER', response.data);
                });
        }
    }

    private selectProvidedWheelchairOption(value: any) {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (serviceRequest.transportation) {
            serviceRequest.transportation.providedWheelchairOption = value;
        }
    }

    private setVisitType(type: string) {
        this.$props.serviceRequest.transportation.visitType = type;
        if (type === 'Procedure') {
            this.$props.serviceRequest.transportation.rideshareService = false;
        } else if (type === 'Non-Procedure') {
            this.$props.serviceRequest.transportation.rideshareService = undefined;
        }
    }

    private handleOption(option: BLSServiceOptions) {
        const { blsServiceOptions } = this.$props.serviceRequest.transportation;

        this.$props.serviceRequest.transportation.blsServiceOptions = blsServiceOptions.includes(option)
            ? blsServiceOptions.filter((item: any) => item !== option)
            : [...blsServiceOptions, option];
    }

    private isActive(option: BLSServiceOptions) {
        return this.$props.serviceRequest.transportation.blsServiceOptions.includes(option);
    }

    private goBack() {
        this.$router.back();
    }

}
